// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/scss/resultadvice.scss
// module id = 364
// module chunks = 2